export default {
  steps: {
    of: 'Pas {current} de {total}',
    title: {
      1: 'Identifica el teu usuari',
      2: 'Comprova la quantitat reemborsable',
      3: 'Introdueix les teves dades bancàries'
    }
  },
  refunds: 'Devolucions',
  actions: {
    accept: 'Acceptar'
  },
  main: {
    start: 'Iniciar procés de devolució',
    refund_unavailable: 'Procés de devolució actualment no disponible.'
  },
  tagId: {
    label: 'ID de la polsera o l\'usuari',
    validate: 'Validar',
    tag_placement:
      'Pots trobar l\'ID del teu xip a la part davantera o posterior.',
    id_description: 'És una cadena de 14 o 15 números i lletres.'
  },
  balance: {
    current: 'Saldo actual',
    comission: 'Despeses de gestió',
    total: 'Reemborsament total',
    refund: 'Procedir al reemborsament',
    message: {
      not_enough_balance: 'Devolució no disponible. Les despeses de gestió superen el saldo actual.',
      balance_too_large: 'Les devolucions per sobre de {amount} no estan automatitzades.'
    }
  },
  bank_data: {
    document: 'Document',
    name: 'Nom',
    surname: 'Primer cognom',
    second_surname: 'Segon cognom',
    phone: 'Número de telèfon',
    email: 'Correu electrònic',
    document_type: 'Tipus',
    confirm_refund: 'Confirmar reemborsament de {amount}',
    hint: {
      phone: 'Inclou el codi del teu país: +34 666 666 666'
    },
    document_types: {
      NATIONAL_ID_CARD: 'DNI',
      PASSPORT: 'Passaport',
      ARG_TAX_DOCUMENT: 'CUIL/CUIT',
      MEXICAN_RFC: 'RFC Mexicano',
      UYU_CI: 'CI Uruguay'
    },
    account_types: {
      IBAN: 'IBAN',
      CBU: 'CBU',
      CLABE: 'CLABE',
      UYU_ACCOUNT: 'UYU Cuenta'
    }
  },
  result: {
    back_to_main: 'Tornar a pàgina principal'
  },
  error: {
    not_found: {
      title: 'Vaja! No hi ha res aquí',
      subheading: 'Accedeix a aquesta aplicació mitjançant lenllaç proporcionat',
      tag: 'Aquest xip no ha estat utilitzat en aquest esdeveniment'
    },
    500: `S'ha produït un error al servidor. Treballem a solucionar-ho!`,
    0:
      'Oops! Sembla que el servidor no està disponible. Torna més tard!',
    bad_request: {
      any: {
        required: 'Obligatori',
        empty: 'Obligatori'
      },
      string: {
        base: 'Obligatori',
        hex: 'ID de xip invàlid. Heu de tenir 14 o 15 dígits.',
        invalid_tag: 'ID de xip invàlid. Revisa els dígits introduïts.',
        min: `No té la longitud mínima`
      },
      iban: {
        invalid: 'IBAN invàlid'
      },
      cbu: {
        invalid: 'CBU invàlid'
      },
      clabe: {
        invalid: 'CLABE invàlid'
      },
      uyu_account: {
        invalid: 'Longitud incorrecta, ha de ser de 14 dígits.'
      },
      email: {
        invalid: 'Correu electrónic invàlid'
      },
      phone: {
        invalid: 'Número de telèfon invàlid. Inclou el codi del teu país: +34 666 666 666'
      },
      cuil_cuit: {
        invalid: 'CUIL/CUIT invàlid'
      },
      mexican_rfc: {
        invalid: 'RFC invàlid'
      }
    }
  },
  message: {
    close: 'Tancar missatge'
  },
  decimal_separator: ',',
  warnings: {
    important: 'Important: ',
    complete_name: "S'han d'emplenar el nom i cognoms del beneficiari al complet, si no és així podria no efectuar-se correctament la devolució."
  }
}
